export function objToArr(value = {}) {
  const obj = Object.assign({}, value);

  const output = [];
  if (!obj) {
    return output;
  }

  Object.keys(obj).forEach((key) => {
    const item = obj[key];
    item.key = key;
    output.push(item);
  });

  return output;
}

export function findById(o, id) {
  if (!o) return null;

  // Early return
  if (o.id === id) {
    return o;
  }
  let result;
  let p;

  for (p in o) {
    if (o.hasOwnProperty(p) && typeof o[p] === 'object') {
      result = findById(o[p], id);
      if (result) {
        return result;
      }
    }
  }
  return result;
}

export function findPathById(project, id, currentPath = '') {
  if (!project) return null;

  // Early return
  if (project.id === id) {
    return currentPath;
  }
  let result;
  let p;

  for (p in project) {
    if (project.hasOwnProperty(p) && typeof project[p] === 'object') {
      result = findPathById(project[p], id, `${currentPath}/${p}`);
      if (result) {
        return result;
      }
    }
  }
  return result;
}

export function prepareItems(items, icon = null) {
  const output = objToArr(Object.assign({}, items)).map((item) => {
    const tmp = item;
    tmp.id = tmp.key;
    tmp.text = tmp.name || '';
    if (icon) {
      tmp.icon = icon;
    }
    return tmp;
  });

  return output;
}



// WEBPACK FOOTER //
// ./src/helpers/index.js